import { Reference } from './types';

export const EMPTY_VALUE_PLACEHOLDER = '-';
export const LIMIT = 25;
export const MIN_SEARCH_TERM_LENGTH = 3;
export const FIELDS_TO_PICK: Array<keyof Reference> = ['id', 'referenceRevId', 'comment'];
